export default {
  title: 'Status kontrolera:',
};
